import { FC, useEffect } from 'react';

export const SkeletonDecorationBox: FC = () => {
	// Inline skeleton style
	const skeletonStyle: React.CSSProperties = {
		background: '#f2f2f4',
		backgroundSize: '400% 100%',
		animation: 'skeleton-loading 1.2s ease-in-out infinite',
		borderRadius: 4,
		minHeight: 24,
		width: '100%',
		marginBottom: 8
	};

	// Add keyframes for skeleton animation
	useEffect(() => {
		const styleId = 'skeleton-loading-keyframes';
		if (!document.getElementById(styleId)) {
			const style = document.createElement('style');
			style.id = styleId;
			style.innerHTML = `
				@keyframes skeleton-loading {
					0% { background-position: 100% 50%; }
					100% { background-position: 0 50%; }
				}
			`;
			document.head.appendChild(style);
		}
	}, []);

	return (
		<>
			<div className="d-flex gap-4">
				<div
					style={{
						...skeletonStyle,
						width: 180,
						height: 20
					}}
				/>
				<div
					style={{
						...skeletonStyle,
						width: 120,
						height: 16
					}}
				/>
				<div
					style={{
						...skeletonStyle,
						width: 220,
						height: 16
					}}
				/>
			</div>
			<div
				style={{
					...skeletonStyle,

					height: 20
				}}
			/>
		</>
	);
};
